import styles from './profile.module.css'
import ProfileForm from './ProfileForm/ProfileForm'

const Profile = () => {
  return (
    <ProfileForm/>
  )
}

export default Profile
